<template lang="pug">
	.cluster-nodes(v-if="showed")
		.card
			.card-header
				i.fa.fa-server
				span Cluster nodes
				.actions
					button.btn.btn-sm.btn-secondary(type="button" @click="requestNodes()")
						i.fa.fa-refresh
						| &nbsp;&nbsp;Refresh
					button.btn.btn-sm.btn-secondary(type="button" @click="openLog()")
						i.fa.fa-exchange
						| &nbsp;&nbsp;Requests
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="close()")
						i.fa.fa-times
			.card-body
				.nodes-table
					table.table
						thead
							tr
								th Status
								th Node
								th Domain
								th Publishers
								th Users
								th Disk free
								th Disk total
								th RAM used
								th RAM free
								th RAM total
								th Uptime
						tbody
							tr(v-for="node in Cluster.getNodes()" :key="node.serverId" :class="{offline: !node.online}")
								td
									span.status-dot(:class="{online: node.online}")
									| {{node.online ? 'Online' : 'Offline'}}
								td
									strong {{node.title || ('Node ' + node.serverId)}}
									span.node-badges
										span.badge.badge-info(v-if="node.serverId === Metadata.ServerId") this node
										span.badge.badge-info(v-if="node.primary") primary
										span.badge.badge-warning(v-if="node.registrar") registrar
								td {{node.domain || '-'}}
								td {{node.online ? node.publishers : '-'}}
								td {{node.online ? node.users : '-'}}
								td {{node.online ? formatBytes(node.disk.free) : '-'}}
								td {{node.online ? formatBytes(node.disk.total) : '-'}}
								td {{node.online ? formatBytes(node.memory.used) : '-'}}
								td {{node.online ? formatBytes(node.memory.free) : '-'}}
								td {{node.online ? formatBytes(node.memory.total) : '-'}}
								td {{node.online ? formatUptime(node.uptime) : '-'}}
				.empty(v-if="!Cluster.getNodes().length")
					span Waiting for data from the server...
</template>

<script>

	import Screen				from './../../mixins/screen'

	import { Server }		from './../../services/Server'
	import { User }			from './../../services/User'
	import { Cluster }		from './../../services/Cluster'

	export default {
		name: "ClusterNodes",
		mixins: [Screen],
		screen: {
			updateOn: ["Cluster Nodes Changed"]
		},
		data() {

			this.Cluster = Cluster;

			return {

			}

		},
		methods: {
			collectData(reason) {

				//При открытии окна запрашиваем у сервера актуальное состояние нод
				if (reason === 'show') this.requestNodes();

			},
			// Запрашиваем у сервера актуальный список нод (доступно только супер-админам).
			// Запрос уходит на свою ноду: она опрашивает остальные и собирает общий список
			requestNodes() {

				if (!User.currentUser?.Tags?.['super-admin']) return;

				Server.sendToServer({
					GetClusterNodes: {}
				}, Server.getPrimaryServerId());

			},
			// Открываем окно потока запросов между нодами кластера
			openLog() {

				Broadcast.call("Show ClusterLog");

			},
			close() {

				this.hide();

			},
			// Человекочитаемый размер в байтах
			formatBytes(bytes) {

				if (bytes === null || bytes === undefined) return '-';

				let units = ['B', 'KB', 'MB', 'GB', 'TB'],
					value = bytes,
					unit = 0;

				while (value >= 1024 && unit < units.length - 1) {

					value /= 1024;
					unit++;

				}

				return `${value.toFixed(unit === 0 || value >= 10 ? 0 : 1)} ${units[unit]}`;

			},
			// Человекочитаемое время работы ноды
			formatUptime(seconds) {

				seconds = parseInt(seconds, 10) || 0;

				let days = Math.floor(seconds / 86400),
					hours = Math.floor((seconds % 86400) / 3600),
					minutes = Math.floor((seconds % 3600) / 60);

				if (days > 0) return `${days}d ${hours}h`;
				if (hours > 0) return `${hours}h ${minutes}m`;

				return `${minutes}m`;

			}
		}
	}
</script>

<style lang="sass">

	.cluster-nodes
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 90%
			max-width: 1200px
			height: fit-content
			max-height: 90vh
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.card-header
				display: flex
				align-items: center
				color: #fff

				i
					margin-right: 8px

				.actions
					display: flex
					align-items: center
					margin-left: auto

					button
						margin-left: 6px
						color: #fff

			.card-body
				overflow-y: auto

			.nodes-table
				padding: 0.5rem 0

				table.table
					width: 100%
					// Текст таблицы светлее заголовков (th), чтобы читался на тёмном фоне
					color: #e4e7ea

					th
						color: #9da5b1
						font-weight: normal
						border-top: none
						border-bottom: 1px solid rgba(0, 0, 0, 0.3)

					td
						border-top: 1px solid rgba(0, 0, 0, 0.15)
						vertical-align: middle

					tr.offline
						td
							color: #9da5b1

					.status-dot
						display: inline-block
						width: 8px
						height: 8px
						margin-right: 6px
						border-radius: 8px
						background-color: #f86c6b

						&.online
							background-color: #4dbd74

					.node-badges
						margin-left: 6px

						.badge
							margin-left: 4px
							font-weight: normal

			.empty
				display: flex
				justify-content: center
				padding: 2rem

				span
					color: #9da5b1

</style>
